/**
 * Product gallery counter — counts image slides only (e.g. 1/6).
 */
(function () {
  const boundLists = new WeakMap();

  function getImageSlides(list) {
    const seen = new Set();
    return Array.from(list.querySelectorAll('.product__media-item[data-media-type="image"]')).filter((slide) => {
      const id = slide.dataset.mediaId;
      if (!id || seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }

  function getActiveIndex(slides, list) {
    const listRect = list.getBoundingClientRect();
    const anchor = listRect.left + listRect.width * 0.35;
    let index = 0;
    let best = Infinity;

    slides.forEach((slide, i) => {
      const rect = slide.getBoundingClientRect();
      const dist = Math.abs(rect.left - anchor);
      if (dist < best) {
        best = dist;
        index = i;
      }
    });

    return index;
  }

  function updateCounter(list) {
    const slider = list.closest('slider-component.product-gallery-slider');
    if (!slider) return;

    const slides = getImageSlides(list);
    const currentEl = slider.querySelector('.slider-counter--current');
    const totalEl = slider.querySelector('.slider-counter--total');
    if (!currentEl || !totalEl) return;

    const total = slides.length;
    const index = total > 0 ? getActiveIndex(slides, list) + 1 : 1;
    const state = boundLists.get(list) || { index: 0, total: 0 };

    const buttons = slider.querySelector('.slider-buttons');
    if (total < 2) {
      buttons?.classList.add('hidden');
    } else {
      buttons?.classList.remove('hidden');
    }

    if (state.total !== total) {
      totalEl.textContent = total;
      state.total = total;
    }

    if (state.index !== index) {
      currentEl.textContent = index;
      state.index = index;
    }

    boundLists.set(list, state);
  }

  function bindGalleryList(list) {
    if (boundLists.has(list)) {
      updateCounter(list);
      return;
    }

    let scrollFrame = null;

    const onScroll = () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = null;
        updateCounter(list);
      });
    };

    boundLists.set(list, { index: 0, total: 0, onScroll });
    list.addEventListener('scroll', onScroll, { passive: true });

    const slider = list.closest('slider-component.product-gallery-slider');
    slider?.addEventListener('slideChanged', onScroll);

    updateCounter(list);
  }

  function initProductGalleryCounters(root = document) {
    root.querySelectorAll('slider-component.product-gallery-slider').forEach((slider) => {
      const list = slider.querySelector('.product__media-list');
      if (list) bindGalleryList(list);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductGalleryCounters());
  } else {
    initProductGalleryCounters();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProductGalleryCounters(event.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      requestAnimationFrame(() => initProductGalleryCounters());
    });
  }
})();
